// Клавиша: «⌘K», «Esc», «[» — в подсказках, пунктах меню и подвале окна. Подсказку клавиши
// ставят рядом с действием (ux.md, раздел 8): в пункте меню, в подсказке кнопки, в палитре.
import { Fragment } from 'react';
import type { HTMLAttributes } from 'react';
import { cx } from '../lib/cx.ts';

export function Kbd({ className, ...rest }: HTMLAttributes<HTMLElement>) {
  return <kbd className={cx('t-kbd', className)} {...rest} />;
}

/**
 * Клавиша действия: строка — одно нажатие («N», «⌘K»); список — нажатия по очереди
 * (['G', 'H'] — «G затем H», как в ux.md: «`G`, затем `H`»).
 */
export type Shortcut = string | readonly string[];

/** Клавиши действия: «N» или «G затем H». */
export function ShortcutKeys({ shortcut, className }: { shortcut: Shortcut; className?: string }) {
  const steps: readonly string[] = typeof shortcut === 'string' ? [shortcut] : shortcut;
  return (
    <span className={cx('kp-shortcut', className)}>
      {steps.map((step, index) => (
        <Fragment key={`${index}-${step}`}>
          {/* Пробелы вокруг «затем» — для текста подсказки и программ чтения: «G затем H». */}
          {index > 0 ? <span className="kp-shortcut-then"> затем </span> : null}
          <Kbd>{step}</Kbd>
        </Fragment>
      ))}
    </span>
  );
}
